import React from 'react'
import { connect } from 'react-redux'
import { Link} from "react-router-dom"
import './headerPC.css'
import axios from 'axios'
import { withRouter } from 'react-router-dom'

import {userList} from '../../redux/chatuser.redux.js'
import {getInFoFn} from '../../redux/chatuser.redux.js'
@withRouter
@connect(
  state=>state.chatuser,
  {userList,getInFoFn}
) 
class HeaderPC extends React.Component{
    constructor(props){
        super(props);
    }
	componentDidMount(){
  		document.getElementById('meta1').setAttribute('content','心享俱乐部回归特权，游戏回归特权，回归特权礼包') 
  		document.getElementById('meta2').setAttribute('content','心享俱乐部全新推出游戏回归特权，心享俱乐部会员通过账号鉴定即可激活回归特权，独享特权包括回归礼包、高额返利、新游试玩等在内的游戏回归特权。') 
  	}
    handleLogin(){		
		const pathname = this.props.location.pathname
		axios.get('/fapi/getLoginURL?redirect_url='+encodeURIComponent(encodeURIComponent(window.location.href)))
	      .then(res=>{
	       	if(res.data.return_code==0){
	       		window.location.href = res.data.redirect_url
	       	}	     
		 })		
    }
    handleLogout(){		
		const MyOrigin = window.location.origin
		this.pathname = MyOrigin +''+ this.props.location.pathname
		window.location.href ="/fapi/logoutB?returnUrl="+encodeURIComponent(this.pathname)
	}
    render() {
        return(
            <div className="headerPc-box">
                <div className="header">
                    <div className="left">
                        <a href="#"></a>
                    </div>
                    <div className="right">
                        <div className="log-box">
                            {
                                this.props.userlist.code===-1 ? <button className="btn h-login" onClick={()=>this.handleLogin()}>登录</button> : null
                            }
                            {
                                this.props.userlist.displayAccount &&<div>
                                <span>{this.props.userlist.displayAccount}</span>
                                <button className="btn h-logout" onClick={()=>this.handleLogout()}>注销</button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default HeaderPC;


// WEBPACK FOOTER //
// ./src/component/headerPC/headerPC.js